import RenderTips from "@/utils/render-tips";
import { Sparkles } from "lucide-react";
import ErrorBoundary from "@/components/ErrorBoundary";

/**
 * Early Mail card shown under a race's tips (/results, /todays-tips).
 * Takes the values returned by `useEarlyMailForRace`.
 * `tipMovementSources` = { raceDay, latest } race data of the same race, so the Early Mail
 * markers can show where each horse is now (see src/utils/tip-movement.js).
 */
export default function EarlyMailRaceTips({
  trackName,
  raceNumber,
  date,
  historicalData,
  isResultsPage = false,
  earlyMailTips,
  earlyMailArrivedAt,
  earlyMailRelativeLabel,
  isEarlyMailLoading,
  isEarlyMailError,
  tipMovementSources = null,
  hideTipMovement = false,
  // true = drawn inside the race tips container (no card of its own), as on /results
  embedded = false,
}) {
  return (
    <>
      {!isEarlyMailLoading &&
        (isEarlyMailError ||
          !Array.isArray(earlyMailTips) ||
          earlyMailTips.length === 0) && (
          <div className="mx-2 mt-2">
            <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 shadow-[0_0_3px_rgba(0,0,0,0.12)] text-xs text-gray-600">
              <Sparkles
                className="w-4 h-4 text-brand-pink"
                aria-hidden="true"
              />
              <span className="">
                <strong>Early Mail</strong> not available for this race.
              </span>
            </div>
          </div>
        )}

      {Array.isArray(earlyMailTips) && earlyMailTips.length > 0 && (
        <div
          className={
            embedded
              ? "early-mail-embedded pt-3 pb-1"
              : "tips-master-container pt-3 pb-1 px-3 mx-2 mt-2 mb-[2px] rounded-lg shadow-[0_0_3px_rgba(0,0,0,0.25)] bg-[rgba(255,255,255,0.9)] backdrop-blur-[1.5px] transition-all duration-500"
          }
        >
          <ErrorBoundary>
            <RenderTips
              externalLeaderboardQueryData={{
                [`${trackName.replace(/\s+/g, "-")}-${raceNumber}-${date}`]: {
                  firstFourData: earlyMailTips,
                  tipUpdatedAt: earlyMailArrivedAt,
                },
              }}
              externalHistoricalData={historicalData}
              externalHasHistoricalData={true}
              externalHasEarlyPredictions={false}
              externalEarlyPredictionsData={{}}
              selectedTrack={trackName}
              selectedRace={raceNumber}
              today={date}
              isChanging={false}
              isMounted={true}
              isResultsPage={isResultsPage}
              isEarlyMail={true}
              earlyMailRelativeLabel={earlyMailRelativeLabel}
              tipMovementSources={tipMovementSources}
              hideTipMovement={hideTipMovement}
              // "Odds generated by Lexi · Show odds % / Show $ price" under the list
              showPriceToggle={true}
            />
          </ErrorBoundary>
        </div>
      )}
    </>
  );
}
